import React, {Component} from 'react';
import AppColors from '../../common/Colors';
import Utils from "../../common/Utils";
import "./Styles.css";
import {Button} from "reactstrap";
import TTLProxy from "../../common/TTLAsyncProxy";

class Page404 extends Component {

    constructor(props){
        super(props);
        this.state = {
          query: {}
        };

        this.proxy = TTLProxy.getInstance();
    }

    componentWillMount(){
        Utils.setWindowTitle('Page Not Found',false);
    }

    render() {

        return (<div className="app flex-row align-items-center" style={{backgroundColor: AppColors.PageBackgroundColor}}>
              <div className="container">
                <div className="row justify-content-center">
                  <div className="col-md-6">

                      <div className="card p-4 border-frame animated fadeIn" style={{ minWidth: 450 }} >

                          <div className="text-center">
                              <h1 style={{ fontSize: 206 }}>404</h1>
                              <b style={{color: "gray"}}>Page not found</b>
                              <p style={{fontSize: 10}}>The page your'e looking for cannot be found. Kindly check you entered the correct page and refresh!</p>

                              <Button color={"green"} style={{borderRadius: 5}} onClick={() =>{

                                  if(this.proxy.isAuthenticated()){
                                      window.location.href = "/";
                                  }
                                  else{
                                      window.location.href = "/login";
                                  }

                              }}><i className="fa fa-home"></i> Go Home</Button>
                          </div>

                      </div>


                  </div>
                </div>
              </div>
            </div>);

    }
}

export default Page404;



// WEBPACK FOOTER //
// ./src/views/Page404/Page404.js